// extracted by mini-css-extract-plugin
export default {"header":"ry","discountBanner":"sy","logo":"ty","maincontainer":"uy","videocontainer":"vy","videowelcome":"wy","videowrapper":"xy","videosale":"yy","loadingcontainer":"zy","footer":"Ay","footerbutton":"By","video":"Cy","logoname":"Ey"};
    if(module.hot) {
      // 1713361650610
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  